import React from 'react';

export default function IconProfile() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5C6.067 1.5 4.5 3.067 4.5 5C4.5 6.933 6.067 8.5 8 8.5C9.933 8.5 11.5 6.933 11.5 5C11.5 3.067 9.933 1.5 8 1.5ZM3.5 5C3.5 2.51472 5.51472 0.5 8 0.5C10.4853 0.5 12.5 2.51472 12.5 5C12.5 7.48528 10.4853 9.5 8 9.5C5.51472 9.5 3.5 7.48528 3.5 5Z"
        fill="#142138"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.01938 11.5848C3.25737 12.7586 3 14.159 3 15C3 15.2761 2.77614 15.5 2.5 15.5C2.22386 15.5 2 15.2761 2 15C2 14.0077 2.29263 12.4081 3.18062 11.0402C4.08567 9.64611 5.60947 8.5 8 8.5C10.3905 8.5 11.9143 9.64611 12.8194 11.0402C13.7074 12.4081 14 14.0077 14 15C14 15.2761 13.7761 15.5 13.5 15.5C13.2239 15.5 13 15.2761 13 15C13 14.159 12.7426 12.7586 11.9806 11.5848C11.2357 10.4372 10.0095 9.5 8 9.5C5.99053 9.5 4.76433 10.4372 4.01938 11.5848Z"
        fill="#142138"
      />
    </svg>
  );
}
